import React from 'react';
import Popup from '../components/Popup';

const Logout = () => {

  return (
    <Popup title={'QUIT'} message={'Do you really want to Quit?'}/>
  );
};

export default Logout;
